import { render } from "./FiltersBar.vue?vue&type=template&id=35555b4c&ts=true&lang=pug"
import script from "./FiltersBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./FiltersBar.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__